import { render, staticRenderFns } from "./regionalCenterList.vue?vue&type=template&id=057d78cb&"
import script from "./regionalCenterList.vue?vue&type=script&lang=js&"
export * from "./regionalCenterList.vue?vue&type=script&lang=js&"
import style0 from "./regionalCenterList.vue?vue&type=style&index=0&id=057d78cb&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports